<section class="participants" data-testid="section-participants">
  <section aria-label="Scheduled attendance">
    <header><h3>Scheduled attendance</h3></header>
    <p class="field-help">Record actual presence for each scheduled attendee. A notice response or an intention to attend does not confirm presence.</p>
    @if (rosterLoading) { <p role="status">Loading attendance roster…</p> }
    @else {
    @if (rosterMessage) { <p role="status">{{ rosterMessage }}</p> }
    <ui-grid width="fill" containerClass="no-panel" [rowData]="rows()" [columnDefs]="columns()"
      [defaultColDef]="columnDefaults" [agGridOptions]="gridOptions" [showPanelHeader]="false"
      [autoHidePaginator]="true" [rowHeight]="48" noRowsHeight="180px"
      [noDataFoundMessage]="rosterMessage || 'No scheduled attendees are listed for this hearing.'"></ui-grid>
    }
    @if (canReadContacts && proceedingId) {
      <p class="field-help roster-link"><a [routerLink]="['/phms/hearing-detail', proceedingId, 'pre-hearing']"
        [queryParams]="{ section: 'victim-notification' }">Participants &amp; notification</a> &mdash; review notice responses and representative or support-person relationships.</p>
    }
  </section>
  <section aria-label="Participation notes">
    <ui-form [config]="inputConfig" [formValues]="values()" [disabled]="!canEdit()" (inputChange)="onInputChange($event)"></ui-form>
    <p class="field-help">Record testimony, statements, representation, or other participation during the hearing.</p>
  </section>
</section>
<ng-template #roleCell let-attendee>
  <span class="role-cell">{{ attendee.role }} @if (attendee.isPresiding) { <span class="pi pi-star-fill" role="img" aria-label="Presiding official" title="Presiding official"></span> }</span>
</ng-template>
<ng-template #sourceCell let-attendee>
  @if (attendee.source === 'panel') { <span [appTerminologyIdentity]="terminologyUsage.panel">{{ text.panel() }}</span> } @else { <span>Participant</span> }
</ng-template>
<ng-template #attendanceCell let-attendee let-params="params">
  <div class="attendance-cell" [attr.data-attendee-key]="attendee.key" (focusin)="revealColumn($event, params)">
    @if (canEdit()) {
      <ui-form [config]="attendee.attendanceConfig" [formValues]="{ attendance: attendanceCode(attendee.key) }"
        subscriptSizing="dynamic" [disabled]="!canEdit()" (inputChange)="setAttendance(attendee.key, $event)"></ui-form>
    } @else { <span>{{ attendanceLabel(attendee.key) }}</span> }
  </div>
</ng-template>
